import { ReactElement, useState } from "react";
import { CalculationState } from "state/state";
import {
  exportZonTypGdeCsv,
  exportZonTypPbgCsv,
  pdfReport,
} from "reports/reports";
import { MunicipalityDto, ScenarioDto } from "dtos/dtos";
import { useHistory } from "react-router-dom";
import { URL } from "myconstants";
import { Metrics } from "calculation/metric";
import { DownloadButton } from "components/common/DownloadButton";
import { Overlay } from "components/common/Overlay";

export function ReportLinks(props: {
  metrics: Metrics;
  calculationState: CalculationState;
  municipality: MunicipalityDto;
  scenario: ScenarioDto;
  parameterSetModifiedAt: string;
}): ReactElement {
  const {
    metrics,
    calculationState,
    municipality,
    scenario,
    parameterSetModifiedAt,
  } = props;
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <div className="flex flex-col space-y-4">
      <Overlay show={loading} text="Erstelle Report ..." />
      <DownloadButton
        label="PDF"
        text="Zusammenfassung Bauzonenkapazität"
        width="w-56"
        onClick={async () => {
          setLoading(true);

          const success = await pdfReport(
            calculationState!,
            municipality.gemeinde,
            municipality.gdeCategory.code,
            scenario,
            parameterSetModifiedAt
          );

          setLoading(false);

          if (!success) {
            history.replace(URL.error);
          }
        }}
      />
      <DownloadButton
        label="CSV"
        text="Bauzonenkapazität pro Zonentyp Gemeinde"
        width="w-56"
        onClick={() => {
          exportZonTypGdeCsv(
            metrics,
            calculationState,
            scenario,
            municipality.gemeinde
          );
        }}
      />
      <DownloadButton
        label="CSV"
        text="Bauzonenkapazität pro Zonentyp PBG"
        width="w-56"
        onClick={() => {
          exportZonTypPbgCsv(
            metrics,
            calculationState,
            scenario,
            municipality.gemeinde
          );
        }}
      />
    </div>
  );
}
